import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import { unregister } from "./registerServiceWorker";
import { StylesProvider } from "@material-ui/core";
import styled from "styled-components";
import App from "./App";
import Theme from "./Theme";
import { SnackbarContainer } from "./services/ui-messaging/SnackbarContainer";

// to add IE support (flexbox will still be mucho broke)
// import "core-js/modules/es.object.assign";
// import "core-js/modules/es.promise";
// import "core-js/modules/es.array.from";

// setup global namespace
window.PartnerPortal = {
  ServiceCache: {},
  RmsApiUrl: "",
};

// create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") as string;
const history = createBrowserHistory({ basename: baseUrl });

// get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

const ThemeWrapper = styled.div`
  font-family: ${Theme.fonts.body};
`;

ReactDOM.render(
  <Provider store={store}>
    <StylesProvider injectFirst>
      <ThemeWrapper>
        <SnackbarContainer />
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </ThemeWrapper>
    </StylesProvider>
  </Provider>,
  document.getElementById("root"),
);

unregister();
